import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import useSearchQuery from '../../../hooks/SearchQueryHook';
import useModal from '../../../hooks/modalHook';
import useUserAccount from '../../../hooks/stateHooks/userAccountHook';
import { useQuery } from '@tanstack/react-query';
import { getPassbookSales } from '../../../api/requests';
import GTable, { ITableRowAction } from '../../../components/elements/GTable/GTable';
import { PassbookSale } from '../../../resources/types';
import Avatar from '../../../components/elements/Avatar';
import { getNameInitials } from '../../../utilities/miscFunctions';
import CediSign from '../../../components/elements/CediSign';
import moment from 'moment';
import DashboardHeader from '../../../components/dashboard/tabs/DashboardHeader';
import { PASSBOOK_STATUS } from '../../../resources/enums';
import List from '../../../components/elements/List';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import StatusBadge from '../../../components/elements/StatusBadge';
import Button from '../../../components/form-control/Button';
import SellPassbook from './SellPassbook';
import Loader from '../../../components/Loader';

interface IProps {
  id?: string;
  showHeader?: boolean;
  showSearch?: boolean;
  status?: PASSBOOK_STATUS
}

export default function PassbookSalesList(props: IProps) {
  const { getProfile, user } = useUserAccount();
  const { ModalComponent, updateModalStates, closeModal } = useModal();

  const { debouncedQuery } = useSearchQuery();
  const showHeader = props.showHeader ?? true;
  const showSearch = props.showSearch ?? false;

  const userId = props.id ?? getProfile().id;

  const { data: passbookSales = [], isLoading, isStale, isFetching, refetch } = useQuery<any, Error>({
    queryKey: [
      'users',
      debouncedQuery,
      userId,
    ],
    queryFn: () => getPassbookSales(
      debouncedQuery,
      undefined,
      userId,
      props.status
    )
  });

  const getTableRowActions = (data: PassbookSale): ITableRowAction[] => {
    const actions: ITableRowAction[] = [];

    return actions;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'M',
        columns: [
          {
            Header: 'Customer',
            accessor: 'customer',
            Cell: (row: any) => {
              return <Link to={`/admin/agents/${row.cell.value?.id}`} className='text-link-main dark:text-link-dark flex items-center gap-2'>
                <Avatar
                  src={row.cell.value?.profileImage}
                  size='xs'
                  nameInitials={getNameInitials(`${row?.cell?.value?.first_name} ${row?.cell?.value?.last_name}`)}
                />
                <span>{`${row?.cell?.value?.name ?? "-"}`}</span>
              </Link>;
            }
          },
          {
            Header: 'Amount',
            accessor: 'amount',
            Cell: (row: any) => {
              return <span> <CediSign /> {row.cell.value ?? 'N/A'}</span>;
            }
          },
          {
            Header: 'Status',
            accessor: 'status',
            Cell: (row: any) => {
              return <StatusBadge status={row.cell.value} />;
            }
          },
          {
            Header: 'Date',
            accessor: 'created_at',
            Cell: (row: any) => {
              return <span>{moment(row.cell.value).format("DD/MM/YYYY")}</span>;
            }
          },
        ]
      }
    ],
    []
  );

  const sellPassbook = () => {
    updateModalStates({
      show: true,
      children: <SellPassbook
        onComplete={(passbookSale: PassbookSale) => {
          refetch();
          closeModal();
        }}
      />,
      title: "Sell Passbook"
    })
  }

  const getListItemElement = (item: Record<string, any>, accessor: string): ReactNode => {
    const value = item[accessor as keyof PassbookSale];

    switch (accessor) {
      case "created_by":
        return <div className="flex items-center gap-3">

          <Avatar
            src={value.profileImage}
            nameInitials={getNameInitials(`${value.first_name} ${value.last_name}`)}
            size={window.innerWidth >= 768 ? "md" : "sm"}
          />

          <div>
            <p className="font-medium text-gray-900">
              {`${value.first_name} ${value.last_name}`}
            </p>
          </div>
        </div>
      case "amount":
        return <div className=""><CediSign /> {value}</div>

      case "created_at":
        return <div className="">{moment(value).format("Do MMM, YYYY")}</div>

      default:
        return <span className="text-gray-600">{value as string}</span>
    }
  }

  if (isLoading) {
    return <Loader message='Loading Passbook sales...' />
  }

  return (
    <div>
      {showHeader && <DashboardHeader
        heading='Passbook Sales'
        rightChildren={
          <div className='flex'>
            <Button
              label='Sell Passbook'
              onClick={sellPassbook}
              className='bg-primary-secondary text-white rounded hover:bg-white hover:border hover:border-primary-secondary hover:text-primary-secondary'
            />
          </div>}
      />}

      <div className='mt-4'>
        {/* {window.innerWidth > 768 ? ( */}
        <GTable
          selectionChanged={(selection: any) => {
            // setSlcMember(selection);
          }}
          columns={columns}
          data={passbookSales}
          tableType="passbook sales"
          // onSearch={(searchString: string) => setSearchString(searchString)}
          searchPlaceholder={'Search by name '}
          // paginationData={policiesPaginationData}
          // onPageChange={handlePageChange}
          // showPerPage={showPerPage}
          // onShowPerPageChange={(page: number) => setShowPerPage(page)}
          // onRowClick={(account: Account) => {
          //   navigate(
          //     `${getDashboardBase()}/policies/${policy.ref
          //     }?filter=${filter}&page=${currentPage}`,
          //     { replace: true }
          //   );
          // }}
          // topActions={getTableTopActions()}
          columnClasses={clsx('first:min-w-[210px] min-w-[10rem] last:min-w-[50px]')}
          // loading={loadingUsers}
          // propBasedColumnClasses={(policy: Policy) => checkComprehensive(policy)}
          tableContainerId="tableId"
          showSearch={showSearch}
        />
        {/* // ) : (
        //   <List */}
        {/* //     list={passbookSales}
        //     columns={["Customer", "Amount", "Status", "Date"]}
        //     accessors={["customer", "amount", "status", "created_at"]}
        //     getListItemElement={getListItemElement}
        //   />
        // )} */}

      </div>
      <ModalComponent />
    </div>
  );
}
